import { SafetyCertificateOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';
import { useIntl, useModel } from '@umijs/max';
import { resolveBrandingText } from '@/helpers/branding';
import { Typography } from 'antd';

const Footer: React.FC = () => {
  const intl = useIntl();
  const { initialState } = useModel('@@initialState');
  return (
    <DefaultFooter
      style={{
        background: 'none',
        marginTop: 'auto', // 确保Footer自动推到页面底部
      }}
      links={[]}
      copyright={
        <React.Fragment>
          {resolveBrandingText(
            intl,
            initialState?.branding?.copyright,
            intl.formatMessage({ id: 'pages.footer.copyright', defaultMessage: '© 赛搏 Ai' }),
          )}
          <br />
          <span style={{ display: 'inline-block', marginTop: 8 }}>
            <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 4, transition: 'all 0.3s' }}>
              <SafetyCertificateOutlined style={{ fontSize: 14 }} />
              <Typography.Text style={{ color: 'inherit' }}>
                <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noreferrer" style={{ color: 'inherit' }}>
                  黔ICP备2025044657号-2
                </a>
              </Typography.Text>
            </span>
          </span>
        </React.Fragment>
      }
    />
  );
};

export default Footer;
